<template>
  <div class="banner1">
    <div>请添加1~12张图片，推荐尺寸180*80。可拖动排序</div>
    <draggable
      v-model="currentInfo.wxSchoolPageItemList"
      @update="datadragEndContent"
      :options="{ animation: 500 }"
    >
      <div
        class="mt20"
        v-for="(item, index) in currentInfo.wxSchoolPageItemList"
        :key="index"
      >
        <div class="flex mt10 jc-sb wx-item-style">
          <el-upload
            :action="fileObj.url"
            :before-upload="beforeUpload"
            :on-success="successListUpdate"
            :headers="reqData"
            :show-file-list="false"
          >
            <img
              class="list-img"
              :src="item.picture"
              @click="updateImg(index)"
            />
          </el-upload>

          <el-button type="danger" @click="deleteBtn(index)"
            >删除<i class="el-icon-delete"
          /></el-button>
        </div>
      </div>
    </draggable>
    <div class="jc-center mt20">
      <el-button type="primary" @click="addBannerBtn()">添加</el-button>
    </div>
  </div>
</template>
<script>
import { codeMixin } from "../../../minix";
export default {
  mixins: [codeMixin],
  methods: {
    addBannerBtn() {
      this.currentInfo.wxSchoolPageItemList.push({
        type: this.currentInfo.type,
        linkUrl: undefined,
        picture:
          "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/tkwx/16541610229014466083854.png",
      });
    },
    deleteBtn(index) {
      this.currentInfo.wxSchoolPageItemList.splice(index, 1);
    },
  },
};
</script>
<style lang="less" scoped>
.banner1 {
  /deep/ .el-upload {
    width: 180px;
    height: 80px;
    .list-img {
      width: 180px;
      height: 80px;
      object-fit: cover;
    }
  }
  .jc-sb {
    padding: 10px;
    border-radius: 6px;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/template/other/other2/setting.vue